import {
    GET_DICTIONARY_COURIERS_ERROR,
    GET_DICTIONARY_COURIERS_REQUEST,
    GET_DICTIONARY_COURIERS_SUCCESS
} from "../constants/dictionaryCouriers";
import {IDictionary} from "../../models/Dictionary";
import {IActionDictionaryCouriers} from "../actions/dictionaryCouriers";


export interface IDictionaryCouriersState {
    loading: boolean
    error: string
    data: IDictionary[]
}

const initialState: IDictionaryCouriersState = {
    data: [],
    loading: false,
    error: ''
};

export default function dictionaryCouriers(state = initialState, action: IActionDictionaryCouriers): IDictionaryCouriersState {
    switch (action.type) {
        case GET_DICTIONARY_COURIERS_REQUEST:
            return {
                data: [],
                loading: true,
                error: ''
            };
        case GET_DICTIONARY_COURIERS_SUCCESS:
            return {
                data: action.payload,
                loading: false,
                error: ''
            };
        case GET_DICTIONARY_COURIERS_ERROR:
            return {
                data: [],
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
}
